var map = {
	"./bg-BG.json": 867,
	"./ca-ES.json": 868,
	"./cs-CZ.json": 869,
	"./de-DE.json": 870,
	"./el-GR.json": 871,
	"./en-US.json": 295,
	"./es-ES.json": 872,
	"./et-EE.json": 873,
	"./fi-FI.json": 874,
	"./fr-FR.json": 875,
	"./he-IL.json": 876,
	"./it-IT.json": 877,
	"./ja-JP.json": 878,
	"./ko-KR.json": 879,
	"./nb-NO.json": 880,
	"./nn-NO.json": 881,
	"./pl-PL.json": 882,
	"./pt-BR.json": 883,
	"./ro-RO.json": 884,
	"./ru-RU.json": 885,
	"./sv-SE.json": 886,
	"./tr-TR.json": 887,
	"./zh-CN.json": 888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 866;